// DO NOT MODIFY, this file is autogenerated by tools/build.ts
import { ɵzoneWrap } from '@angular/fire';
import {
  traceUntil as _traceUntil,
  traceUntilComplete as _traceUntilComplete,
  traceUntilFirst as _traceUntilFirst,
  traceWhile as _traceWhile
} from 'rxfire/performance';

export const traceUntil = ɵzoneWrap(_traceUntil, true);
export const traceUntilComplete = ɵzoneWrap(_traceUntilComplete, true);
export const traceUntilFirst = ɵzoneWrap(_traceUntilFirst, true);
export const traceWhile = ɵzoneWrap(_traceWhile, true);
